import wrappedAxios from './wrappedAxios';

import { HOTELS_API_URL } from 'config';

export const createCallbackRequest = async ({ payload }) => {
  const response = await wrappedAxios({
    url: `${HOTELS_API_URL}/request-callback`,
    method: 'post',
    data: payload,
  });

  return response.data;
};
